<template>
  <div class="write-container" v-loading="loading">
    <h1 v-if="writeStatus == 1" id="inActiveTime" style="display: none" />
    <div v-if="writeStatus == 0" class="form-container">
      <div class="project-form-package">
        <img v-if="writeNotStartImg" style="width: 100%" :src="writeNotStartImg" />

        <div v-else class="project-form-main flex-column">
          <div class="svg-list">
            <span class="svg-list-item svg-list-item-yellow"><svg-icon name="yellow" /></span>
            <span class="svg-list-item svg-list-item-green"><svg-icon name="green" /></span>
          </div>
          <div class="project-form-item project-form-end project-form-item-default">
            <div class="flex-column" style="align-items: center">
              <img class="form-end-img" src="@/assets/images/form-end.png" alt="" />
              <span>{{ writeNotStartPrompt || '本次调研活动已经结束，感谢您的参与' }}</span>
            </div>
            <span class="text-center support-text">{{ getDevSupport }} - 提供技术支持</span>
          </div>
        </div>
      </div>
    </div>
    <div v-cloak v-if="writeStatus == 3">
      <el-card class="pwdinput-card text-center">
        <div slot="header" class="clearfix">
          <span> 请输入密码填写</span>
        </div>
        <el-input v-model="writePassword" placeholder="请输入密码填写" />
        <el-button class="width50 mt20" type="primary" @click="handleCheckWritePwd"> 确定</el-button>
      </el-card>
    </div>
    <div v-if="writeStatus == 1" class="form-container">
      <biz-project-form
        v-if="formConfig.formKey"
        ref="bizProjectForm"
        :form-config="formConfig"
        :requestUrl="requestUrl"
      />
    </div>
    <!-- <div v-cloak v-if="writeStatus == 2" class="title-icon-view">
      <div v-if="userFormSetting.submitShowType === 2" v-html="userFormSetting.submitShowCustomPageContent" />
      <el-result v-else :title="'提交成功'" icon="success" />
    </div> -->
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import BizProjectForm from '@/components/FormGen/BizProjectForm'
// import 'tduck-form-generator/dist/TduckForm.css'
import { getQueryString } from '@/utils'
import { parseTime } from '@/utils/tduck'
import constants from '@/utils/constants'
import { removeFormData } from '@/utils/db'
import { getAuthorizationUrl, getAuthorizationUserInfo, getWxSignature } from '@/api/project/wxmp'
import { isWxEnv, onlyWxOpenHandle, setWxConfig } from './wx'
import TduckFormMixin from '../TduckFormMixin'
import { createFormResultRequest, publicCreateFormResultRequest, viewFormResultRequest } from '@/api/project/data'
import {
  checkWritePwdRequest,
  getPublicSettingsRequest,
  getWriteSettingStatusRequest,
  participateActivity
} from '@/api/project/setting'
import { jumpUrl, goBack } from './SubmitJump'
import { checkWriteCountCap, saveWriteCount } from '@/views/form/write/DeviceWriteCount'
import { isMobile } from '@/utils'

const uaParser = require('ua-parser-js')
const ua = uaParser(navigator.userAgent)

require('@/utils/ut')

export default {
  name: 'WriteView',
  components: {
    BizProjectForm
  },
  mixins: [TduckFormMixin],
  props: {
    // 1：公开填写 2：指定成员填写
    writeType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      requestUrl: '/user/form/release',
      formKey: '',
      writePassword: '',
      inActiveTime: 0,
      formConfig: {
        formKey: '',
        preview: false,
        showBtns: true,
        showItem: 'start'
      },
      writeStatus: 1, // 0-不允许填写， 1-进入填写， 2-填写完成，3-输入密码填写
      // 不允许填写的提示信息
      writeNotStartPrompt: '',
      // 不允许填写的图片展示
      writeNotStartImg: '',
      userFormSetting: {},
      // 微信授权地址
      wxAuthorizationUrl: '',
      wxAuthorizationCode: '',
      wxUserInfo: {},
      wxSignature: {},
      // 待提交表单数据
      submitFormData: {
        completeTime: null,
        formKey: null,
        submitOs: ua.os.name,
        submitBrowser: ua.browser.name,
        submitUa: ua,
        wxUserInfo: null,
        wxOpenId: null,
        originalData: null,
        startTime: null // 开始时间
      },
      // 提交后返回的数据
      submitResult: {
        // 随机编号
        randomNumberText: '',
        // 考试成绩
        examScoreText: ''
      },
      loading: false,
      memberMarketingActivities: {},
      userAccesstoken: '',
      writeNotLimitType: null // 接口返回的限制类型
    }
  },
  computed: {
    getDevSupport() {
      let support = localStorage.getItem('FORM-SUPPORT')
      return support ? support : '大头软件'
    }
  },
  provide() {
    return {
      formWriteSubmit: (params) => this.submitForm(params),
      formConfig: this.formConfig
    }
  },
  async created() {
    this.formKey = this.$route.query.key || this.$route.params.key
    this.requestUrl = `/user/form/release/${this.formKey}`
    const { code, products, province, city, token } = this.$route.query
    this.userAccesstoken = token || ''
    this.$store.dispatch('form/setLogicParams', {
      code: code || '',
      product: products || '',
      province: province || '',
      city: city || ''
    })

    // cookie获取微信用户信息
    this.getCookieAuthorizationUserInfo()
    // 微信授权重定向到该页 会携带code参数
    let wxCode = getQueryString('code')
    if (wxCode) {
      this.wxAuthorizationCode = wxCode
      await this.getWxAuthorizationUserInfo()
    }
    console.log('当前页面url', window.location.href)
    // 微信逻辑授权结束 授权地址
    this.getWxAuthorizationUrl()
    // 检查是否能进入填写
    await this.queryProjectSettingStatus()
    // 查询相关设置 检查是否能打开等
    let settingRes = await this.queryProjectSetting()

    this.memberMarketingActivities = settingRes.data.memberMarketingActivities
      ? settingRes.data.memberMarketingActivities
      : {}

    // 非微信环境不加载微信相关 加快访问速度
    if (constants.enableWx && isWxEnv()) {
      // 加载微信相关 获取签名
      getWxSignature({ url: window.location.href }).then((res) => {
        this.wxSignature = res.data
        setWxConfig(this.wxSignature, settingRes.data)
      })
    }
    viewFormResultRequest(this.formKey).then(() => {})
    this.submitFormData.startTime = parseTime(new Date())

    if (this.writeNotLimitType === 'ORDER_LIMIT_COUNT_ERROR' && this.writeStatus === 0) {
      // 报错时，给rn环境发信息，因为可能是重复次数的
      this.sendActivityMsgToRN()
    }
  },
  mounted() {
    window.onpageshow = function (event) {
      // 判断是否是后退进入
      if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        console.log('---是后退进入')
        goBack()
      }
    }
  },
  methods: {
    async queryProjectSettingStatus() {
      const { code, orderid, products, province, city, userCardNo } = this.$route.query

      // 是否能进入填写
      const res = await getWriteSettingStatusRequest({
        formKey: this.formKey,
        type: this.writeType,
        wxOpenId: this.wxUserInfo ? this.wxUserInfo.openid : '',
        userCardNo,
        products,
        code,
        orderid,
        province,
        city
      })
      if (!res.data) {
        const { msg, picUrlMap, limitType } = res
        this.writeNotStartPrompt = msg
        this.writeNotStartImg = isMobile ? picUrlMap?.MOBILE || '' : picUrlMap?.PC || ''
        this.writeStatus = 0
        this.writeNotLimitType = limitType
      }
      return res.data
    },
    getCookieAuthorizationUserInfo() {
      // cookie缓存拿一次 没有的话调接口拿
      let wxUserInfo = Cookies.get('wxUserInfo')
      if (wxUserInfo) {
        wxUserInfo = JSON.parse(wxUserInfo)
        console.log(wxUserInfo)
        if (wxUserInfo.openid) {
          this.wxUserInfo = wxUserInfo
        }
      }
    },
    getWxAuthorizationUserInfo() {
      // 根据code 获取用户授权信息
      let wxAuthorizationCode = this.wxAuthorizationCode
      return getAuthorizationUserInfo({
        code: wxAuthorizationCode
      }).then((res) => {
        if (res.data) {
          console.log('wxuser')
          this.wxUserInfo = res.data
          Cookies.set('wxUserInfo', JSON.stringify(res.data))
          console.log(this.wxUserInfo)
        }
      })
    },
    getWxAuthorizationUrl() {
      // 获取微信授权url地址
      getAuthorizationUrl({ url: window.location.href }).then((res) => {
        if (res.data) {
          this.wxAuthorizationUrl = res.data
        }
      })
    },
    async queryProjectSetting() {
      // 填写设置
      let res = await getPublicSettingsRequest(this.formKey)
      this.formConfig.formKey = this.formKey
      if (res.data) {
        this.userFormSetting = res.data
        this.formConfig.setting = res.data
        // 设备填写次数校验
        this.checkDeviceWriteLimit()
        // 仅在微信环境打开
        if (res.data && res.data.onlyWxWrite) {
          // 记录微信用户信息
          if (res.data.recordWxUser && !this.wxAuthorizationCode) {
            if (Object.keys(this.wxUserInfo).length === 0) {
              location.href = this.wxAuthorizationUrl
            }
          } else {
            onlyWxOpenHandle()
          }
        }
        // 开启了密码填写
        if (res.data && res.data.passwordWriteStatus) {
          this.writeStatus = 3
        }
      }
      return res
    },
    /**
     * 检查设备填写次数
     */
    checkDeviceWriteLimit() {
      if (this.userFormSetting.deviceWriteCountLimitStatus) {
        const flag = checkWriteCountCap(this.formKey, this.userFormSetting.deviceWriteCountLimit)
        if (flag) {
          this.writeNotStartPrompt = this.userFormSetting.deviceWriteCountLimitText
          this.writeStatus = 0
        }
        return flag
      }
    },
    handleCheckWritePwd() {
      checkWritePwdRequest({
        formKey: this.formKey,
        password: this.writePassword
      }).then((res) => {
        this.writeStatus = 1
      })
    },
    async submitForm(data) {
      this.loading = true
      try {
        // 完成时间
        const { submitFormData, wxUserInfo, formKey } = this
        submitFormData.completeTime = document.getElementById('inActiveTime').innerText
        submitFormData.wxUserInfo = wxUserInfo
        submitFormData.wxOpenId = wxUserInfo ? wxUserInfo.openid : ''
        submitFormData.originalData = data.formModel
        submitFormData.formKey = formKey
        submitFormData.formId = data.formId
        submitFormData.formType = this.$refs.bizProjectForm.formConf.formType
        const { code, orderid, products, province, city, userCardNo } = this.$route.query

        let res = null
        // 提交前先校验问卷的状态
        const settingStatus = await this.queryProjectSettingStatus()
        if (!settingStatus) {
          this.loading = false
          return
        }
        if (this.writeType === 1) {
          let url = `/user/form/data/public/create?code=${code || ''}&orderid=${orderid || ''}&products=${
            products ? encodeURIComponent(products) : ''
          }&province=${province || ''}&city=${city || ''}&userCardNo=${userCardNo || ''}`
          res = await publicCreateFormResultRequest(url, submitFormData)
        } else {
          res = await createFormResultRequest(submitFormData)
        }
        this.handleSubmitSuccess(res.data)
        this.formConfig.showItem = 'end'
        this.loading = false
      } catch (err) {
        console.log({ err })
        this.loading = false
      }
    },
    // 提交成功后处理
    handleSubmitSuccess(data) {
      this.submitResult = data
      // 删除临时缓存数据
      removeFormData(this.formKey)
      // 如果开启了设备填写次数限制 则保存记录
      saveWriteCount(this.formKey)
      // 如果问卷设置了【提交问卷奖励】开关，并且有token(在登陆状态下)则直接参与活动发券
      if (this.memberMarketingActivities.enable) {
        if (this.userAccesstoken) {
          this.handleClickActivity()
        } else {
          // 让pad去判读
          this.sendActivityMsgToRN()
        }
      }
      // this.writeStatus = 2
      if (this.userFormSetting.submitJump) {
        jumpUrl(this.userFormSetting.submitJumpUrl, data.id)
      }
    },
    handleClickActivity() {
      participateActivity({ accessToken: this.userAccesstoken, formKey: this.formKey }).then((res) => {
        this.$message({
          message: res.msg,
          type: res.code === 200 ? 'success' : 'waring',
          duration: 8000
        })
        if (res.code === 200) {
          // 通知pad领取成功
          this.sendActivityMsgToRN()
        } else {
          // 把报错消息发过去
          this.sendActivityMsgToRN({
            errMsg: res.msg ?? '领取失败(QvQ)'
          })
        }
      })
    },
    // 点击领取活动票券给rn发消息
    sendActivityMsgToRN(data = {}) {
      if (!window.ReactNativeWebView) return
      // 判断是否rn环境，给rn项目发消息
      const msgData = JSON.stringify({
        type: 'CLICK_TO_RECEIVE_EVENT', // 事件类型
        activityId: this.memberMarketingActivities.activityId ?? '',
        ...data
      })
      window.ReactNativeWebView.postMessage(msgData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/project.scss';
.write-container {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

.title-icon-view {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.icon-view {
  width: 59px;
  height: 59px;
  border-radius: 100px;
  background-color: #0076ff;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.success-icon {
  text-align: center;
  color: white;
  font-size: 30px;
}

.pwdinput-card {
  width: 350px;
  margin: 200px auto;
  min-height: 200px;
}
::v-deep .project-form {
  padding: 20px;
}
.form-container {
  height: 100vh;
}
</style>
